import EditPassword from "@/views/user_profile/change_data/EditPassword.vue";

export default [
  {
    path: "/up/change_data/edit_password",
    name: "up_change_data_edit_password_path",
    component: EditPassword,
  },
];
